import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { VacationsRepository, VACATIONS_REPOSITORY } from '@app/domain/repositories/mot/vacations.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { LababsVacations, VacationsYear } from '@app/entities/models/lababs/lababs-vacations.model';
import { SignedVacations } from '@app/entities/models/mot/signed-vacations/signed-vacations.model';
import { StorageService, STORAGE_CONSTANTS } from '@app/services/storage';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

import { VacationsUseCases } from './vacations.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class VacationsUseCasesImpl implements VacationsUseCases {
  private selectedYear!: string;
  #vacationsRepository: VacationsRepository = inject(VACATIONS_REPOSITORY);

  constructor(private storage: StorageService) {}

  getLababsVacations(): Observable<LababsVacations[]> {
    return this.#vacationsRepository.getLababsVacations();
  }

  getExtraInfo(year?: string): Observable<MSafeAny> {
    return this.#vacationsRepository.getExtraInfo(year);
  }

  getSignedVacations(): Observable<SignedVacations[]> {
    return this.#vacationsRepository.getSignedVacations();
  }

  getAbsenceAnnualYears(): Observable<VacationsYear[]> {
    return this.#vacationsRepository.getAbsenceAnnualYears();
  }

  getSelectedYear(): string {
    return this.selectedYear;
  }

  onError(): Observable<ErrorMsgEnum> {
    return this.#vacationsRepository.onError$;
  }

  setSelectedYear(year: string) {
    this.selectedYear = year;
    this.storage.setItems([{ key: STORAGE_CONSTANTS.VACATIONS_YEAR, value: this.selectedYear }]);
  }
}
